import ProfileName from '@/screens/ProfileName';

export default function PrivateProfileNameRoute() {
  return <ProfileName />;
}
